import { axiosRef } from ".";

export const fetchLmsItemsList = (payload: any) => {
  let url = `/business_central/lms/items?job_no=${payload?.job_no}&`;
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.page !== undefined) {
    url = url + `page=${payload.page}&`;
  }
  if (payload && payload.pageSize !== undefined) {
    url = url + `page_size=${payload.pageSize}&`;
  }
  if (payload && payload.search && payload.search !== "") {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.location && payload.location !== "") {
    url = url + `location=${payload.location}&`;
  }
  if (payload && payload.accepted_date && payload.accepted_date !== "") {
    url = url + `accepted_date=${payload.accepted_date}&`;
  }
  if (payload && payload.recieved_date && payload.recieved_date !== "") {
    url = url + `received_date=${payload.recieved_date}&`;
  }
  if (payload && payload.status && payload.status !== "") {
    url = url + `status=${payload.status}&`;
  }
  if (payload && payload.priority && payload.priority !== "") {
    url = url + `priority=${payload.priority}&`;
  }
  if (payload && payload.manifest_no && payload.manifest_no !== "") {
    url = url + `manifest_no=${payload.manifest_no}&`;
  }
  return axiosRef.get(url);
};
export const fetchLmsLineItemsList = (payload: any) => {
  let url = `/business_central/lms/line_items?job_no=${payload.job_no}&`;
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.page !== undefined) {
    url = url + `page=${payload.page}&`;
  }
  if (payload && payload.pageSize !== undefined) {
    url = url + `page_size=${payload.pageSize}&`;
  }
  if (payload && payload.search && payload.search !== "") {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.origin && payload.origin !== "") {
    url = url + `origin=${payload.origin}&`;
  }
  if (payload && payload.site && payload.site !== "") {
    url = url + `site=${payload.site}&`;
  }
  if (payload && payload.order_date && payload.order_date !== "") {
    url = url + `order_date=${payload.order_date}&`;
  }
  if (payload && payload.posting_date && payload.posting_date !== "") {
    url = url + `posting_date=${payload.posting_date}&`;
  }
  if (payload && payload.priority && payload.priority !== "") {
    url = url + `priority=${payload.priority}&`;
  }
  if (payload && payload.barcode && payload.barcode !== "") {
    url = url + `barcode=${payload.barcode}&`;
  }
  return axiosRef.get(url);
};
export const getManifestNo = (payload: any) => {
  let url = `/business_central/lms/manifests?job_no=${payload?.job_no}&`;
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.page !== undefined) {
    url = url + `page=${payload.page}&`;
  }
  if (payload && payload.pageSize !== undefined) {
    url = url + `page_size=${payload.pageSize}&`;
  }
  if (payload && payload.search && payload.search !== "") {
    url = url + `search=${payload.search}&`;
  }
  return axiosRef.get(url);
};
export const getItemsDetails = (id: string) =>
  axiosRef.get(`/business_central/lms/items/${id}`);
export const getItemsHistory = (barcode: string) =>
  axiosRef.get(`/business_central/lms/items/${barcode}/history`);
export const getItemsDocs = (id: string) =>
  axiosRef.get(`/business_central/lms/items/${id}/docs`);

export const getItemPdf = (barcode: string) =>
  axiosRef.get(`/business_central/lms/report/item_history/${barcode}`);
// Consolidation

export const getLegPdf = (manifest_no : string , leg_no : number) =>
  axiosRef.get(`/business_central/lms/report/freight_manifest/${manifest_no}/${leg_no}`);
// Consolidation
export const getItemDocDownloadLink = (item_no: string, line_no: string) =>
  axiosRef.get(`/business_central/lms/items/${item_no}/docs/${line_no}`);
// Consolidation

export const fetchLmsConsolidationList = (payload: any) => {
  let url = `/business_central/lms/consolidation?`;
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.page !== undefined) {
    url = url + `page=${payload.page}&`;
  }
  if (payload && payload.pageSize !== undefined) {
    url = url + `page_size=${payload.pageSize}&`;
  }
  if (payload && payload.search && payload.search !== "") {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.location && payload.location !== "") {
    url = url + `location=${payload.location}&`;
  }
  if (payload && payload.accepted_date && payload.accepted_date !== "") {
    url = url + `accepted_date=${payload.accepted_date}&`;
  }
  if (payload && payload.recieve_date && payload.recieve_date !== "") {
    url = url + `recieve_date=${payload.recieve_date}&`;
  }
  if (payload && payload.status && payload.status !== "") {
    url = url + `status=${payload.status}&`;
  }
  if (payload && payload.priority && payload.priority !== "") {
    url = url + `priority=${payload.priority}&`;
  }
  return axiosRef.get(url);
};

export const fetchLMSCarriersList = (payload?: any) => {
  let url = `/business_central/lms/carrier_list?`;
  if (payload && payload?.pageSize) {
    url = url + `page_size=${payload.pageSize}&page=${payload.page}&`;
  }
  if (payload && payload.search && payload.search !== "") {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  return axiosRef.get(url);
};
export const fetchLMSLocationList = (payload?: any) => {
  let url = `/business_central/lms/location_list?`;
  if (payload && payload?.pageSize) {
    url = url + `page_size=${payload.pageSize}&page=${payload.page}&`;
  }
  if (payload && payload.search && payload.search !== "") {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  return axiosRef.get(url);
};
